import { softDelete, timestamps, uuid } from '@snap-types/models/common';
import {
  PriceSegmentType,
  priceSegmentTypeSchema,
} from '@snap-types/models/price-segment/enums';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

const d = schema.t.dec;

export const columns = {
  uuid,
  sortOrder: z.int().default(0),
  priceSegmentType: priceSegmentTypeSchema,
  priceStrategyConfigUuid: uuid,
  enabled: z.boolean().default(true),

  createdByUserUuid: uuid.nullish(),

  ...timestamps,
  ...softDelete,
} as const;

export const customerPotentialColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.CustomerPotential),
  low: d.fromUnknown,
  medium: d.fromUnknown,
  high: d.fromUnknown,
});

export const customerPortalsColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.CustomerPortals),
  portalsAdjustment: d.fromUnknown,
});

export const productOperationsCountColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.ProductOperationsCount),
  threshold: schema.t.num.fromString.pipe(
    z.int({ error: 'Must be an integer' }),
  ),
  ltAdjustment: d.fromUnknown,
  gteAdjustment: d.fromUnknown,
});

export const productComplexityColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.ProductComplexity),
  simple: d.fromUnknown,
  moderate: d.fromUnknown,
  complex: d.fromUnknown,
});

export const marketIndustryColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.MarketIndustry),
  defaultAdjustment: d.fromUnknown,
});

export const lastTransactionAgeColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.LastTransactionAge),
  defaultAdjustment: d.fromUnknown,
});

export const lastGrossMarginColumns = z.object({
  priceSegmentType: z.literal(PriceSegmentType.LastGrossMargin),
  defaultAdjustment: d.fromUnknown,
});
